export const API_BASE_URL = "https://hayvan-sahiplendirme-backend.vercel.app";

export const apiUrl = (path) => {
  if (!path) return API_BASE_URL;
  return `${API_BASE_URL}${path.startsWith("/") ? path : `/${path}`}`;
};
